import { useMemo, useState } from 'react';
import { Folder, ListTodo } from '@/components/ui/icons';
import { useDb } from '@/lib/store';
import { useWorkspaceId } from '@/lib/nav';
import { foldersOf, listsOf, spacesOf } from '@/lib/hierarchy';
import { MenuSearch } from '@/components/ui/Menu';
import { SpaceAvatar } from '@/shell/WorkspaceLogo';

/** Searchable List picker (space › folder › list). */
export function MoveTaskMenuPicker({ onPick }: { onPick: (listId: string) => void }) {
  const ws = useWorkspaceId();
  const db = useDb((d) => d);
  const [q, setQ] = useState('');
  const rows = useMemo(() => {
    const out: { kind: 'space' | 'folder' | 'list'; id: string; name: string; depth: number }[] = [];
    for (const s of spacesOf(db, ws)) {
      out.push({ kind: 'space', id: s.id, name: s.name, depth: 0 });
      for (const f of foldersOf(db, s.id)) {
        out.push({ kind: 'folder', id: f.id, name: f.name, depth: 1 });
        for (const l of listsOf(db, s.id, f.id)) out.push({ kind: 'list', id: l.id, name: l.name, depth: 2 });
      }
      for (const l of listsOf(db, s.id, null)) out.push({ kind: 'list', id: l.id, name: l.name, depth: 1 });
    }
    if (!q) return out;
    return out.filter((r) => r.kind === 'list' && r.name.toLowerCase().includes(q.toLowerCase()));
  }, [db, ws, q]);
  return (
    <div className="menu" style={{ width: 280, maxHeight: 380 }}>
      <MenuSearch value={q} onChange={setQ} placeholder="Search Lists..." />
      {rows.map((r) =>
        r.kind === 'list' ? (
          <button key={r.id} className="menu-item" style={{ paddingLeft: 8 + r.depth * 14 }} onClick={() => onPick(r.id)}>
            <ListTodo size={14} className="faint" />
            <span className="truncate">{r.name}</span>
          </button>
        ) : (
          <div key={r.id} className="menu-label row gap-6" style={{ paddingLeft: 8 + r.depth * 14 }}>
            {r.kind === 'space' ? <SpaceAvatar spaceId={r.id} size={14} /> : <Folder size={13} />}
            {r.name}
          </div>
        ),
      )}
    </div>
  );
}
